import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './PageDot.module.scss';

const cx = classnames.bind(styles);

const PageDot = ({className, active}) => {
  return (
    <div className={cx('dot', {active}, className)} />
  )
}

PageDot.propTypes = {
  className: PropTypes.string,
}

PageDot.defaultProps = {
  className: '',
}

export default PageDot;
